export default {
  // actions
  addMetadatum: function(metadatum, index) {
    this.metadata[index] = metadatum
  },
  deleteMetadatum: function(index) {
    delete this.metadata[index]
  },
  updateMetadataIndexAfter: function(rowIndex, changeValue) {
    let keys = Object.keys(this.metadata)
    let updatedKeys = {}
    keys.forEach(index => {
      let metadatum = this.metadata[index]
      let metadatumIndex = this.splitIndex(index)
      let row = parseInt(metadatumIndex.row)
      if (row >= rowIndex) {
        metadatum.index = this.getMetadataIndex(metadatumIndex.spreadsheet, row + changeValue)
      }

      updatedKeys[metadatum.index] = metadatum
    })

    this.metadata = updatedKeys
  },
  addNewRowMetadata: function({ rowIndex, metadatum }) {
    this.incrementMetadataIndexAfter(rowIndex)
    let index = this.getCurrentMetadataIndex(rowIndex)

    if (metadatum) {
      this.addMetadatum(metadatum, index)
    } else if (!this.getMetadata(index)) {
      metadatum = { index }
      this.addMetadatum(metadatum, index)
    }

    // metadatum.isNewRow = true
    this.triggerMetadata()
  },
  incrementMetadataIndexAfter: function(rowIndex) {
    this.updateMetadataIndexAfter(rowIndex, +1)
  },
  decrementMetadataIndexAfter: function(rowIndex) {
    this.updateMetadataIndexAfter(rowIndex, -1)
  },
  setDeleteRowMetadata: function({ rowIndex, state }) {
    let index = this.getCurrentMetadataIndex(rowIndex)
    let metadatum = this.getMetadata(index)
    if (!metadatum) {
      metadatum = {}
      this.addMetadatum(metadatum, index)
    }

    metadatum.isDeleted = state
    this.triggerMetadata()
  },
  deleteRowMetadata: function(rowIndex) {
    let index = this.getCurrentMetadataIndex(rowIndex)
    let metadatum = this.getMetadata(index)
    if (metadatum) {
      this.deleteMetadatum(index)
    }

    this.decrementMetadataIndexAfter(rowIndex)
    this.triggerMetadata()

    return metadatum
  },
  // getters
  getMetadataIndex: function(spreadsheet, row) {
    return `${spreadsheet}-${row}`
  },
  getCurrentMetadataIndex: function(row) {
    return this.getMetadataIndex(this.index, row)
  },
  getMetadata: function(index) {
    return this.metadata[index]
  },
  getRowMetadatum: function(location, metadata) {
    let index = `${this.index}-${location}`

    if (metadata) {
      return metadata[index]
    } else {
      return this.getMetadata(index)
    }
  },
  metadataResetter: function() {
    const resetter = (locationString) => {
      let location = locationString.split('-')
      let metadata = this.getMetadata(`${location[0]}-${location[1]}`)

      if (metadata.isDeleted && !metadata.isNewRow) {
        metadata.isDeleted = false
      } else if (metadata.isNewRow && !metadata.isDeleted) {
        metadata.isDeleted = true
      }
      this.triggerMetadata()
    }

    return resetter
  },
  getCellMetadatum: function(location, metadata) {
    let lastDash = location.lastIndexOf('-')

    let index
    if (lastDash != -1) {
      index = location.substring(0, location.lastIndexOf('-'))
    } else {
      index = `${this.index}-${location}`
    }

    if (metadata) {
      return metadata[index]
    } else {
      return this.getMetadata(index)
    }
  },
}